import script from "./PCPartsDetailsCardMainBodyMainActions.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardMainBodyMainActions.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardMainBodyMainActions.vue?vue&type=style&index=0&id=9e4529aa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e4529aa"]])

export default __exports__